import { shape, string } from "prop-types";

const StepType = shape({ label: string, status: string });

export default StepType;
